import RaceSponsorInfo from './RaceSponsorInfo';

export default RaceSponsorInfo;
